import { Component, Input, forwardRef } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

import { sortBy } from 'underscore';
import { BaseControlValueAccessor } from 'rev-shared/util/BaseControlValueAccessor';

import styles from './SortableSelectionGrid.module.less';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

interface ISelection {
	id: string;
	$isSelected: boolean;
}

@Component({
	selector: 'sortable-selection-grid',
	templateUrl: './SortableSelectionGrid.Component.html',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => SortableSelectionGridComponent),
		multi: true
	}],
	standalone: false
})
export class SortableSelectionGridComponent extends BaseControlValueAccessor<ISelection[]> {
	@Input() public options: ISelection[];
	@Input() public isSelected: (item: ISelection) => boolean;
	@Input() public isForceSelected: (item: ISelection) => boolean;
	@Input() public getName: (item: ISelection) => string;
	@Input() public getSubheading: (item: ISelection) => string;
	@Input() public setSelected: (item: ISelection, isSelected: boolean) => void;

	public allOptions: ISelection[];
	public readonly styles = styles;

	public writeValue(val: ISelection[]): void {
		super.writeValue(val);
		this.allOptions = sortBy(this.options, option => {
			const index = this.value?.findIndex(({ id }) => id === option.id);

			if(index < 0 ) {
				return Number.MAX_VALUE;
			}
			return index;
		});

		this.allOptions.forEach(option => {
			const selectedItem = this.value?.find(({ id }) => id === option.id);
			Object.assign(option,
				selectedItem || {}, {
					$isSelected: selectedItem && this.isSelected(selectedItem) || this.isForceSelected(option)
				}
			);
		});

		this.updateModel();
	}

	public selectOption(field: ISelection, isSelected: boolean): void {
		this.setSelected(field, isSelected);
		this.updateModel();
	}

	private updateModel(): void {
		this.updateModelValue(this.allOptions.filter(f => f.$isSelected));
	}

	public drop(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.allOptions, event.previousIndex, event.currentIndex);
		this.updateModel();
	}
}
